// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeViewComplianceSection-LockedOutButton_cls1__X2Hlk","cls2":"PayeeViewComplianceSection-LockedOutButton_cls2__0n0e9 PayeeViewComplianceSection-LockedOutButton_cls1__X2Hlk"};